var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time text-center mt-2 mb-2"},[_c('p',[_vm._v(_vm._s(_vm.currentTime))]),_c('p',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(this.$moment().utcOffset(7).format('dddd'))+" - "+_vm._s(this.$moment().utcOffset(7).format('l')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }